import i18n from "i18next";
import * as yup from "yup";

import { Shape } from "@/core/yup";

import { DriverLicenseAndIdFormTypes } from "./DriverLicenseAndIdForm";

export const formSchema = (birthdate: Date) =>
    yup.object<{}, Shape<DriverLicenseAndIdFormTypes>>({
        validTo: yup.date().onFuture().nullable(),
        validFrom: yup
            .date()
            .min(birthdate || new Date(new Date().getFullYear() - 120, 1, 1), i18n.t("Validations.DateBeforeBirthDate"))
            .presentOrPast()
            .nullable(),
        issueDate: yup
            .date()
            .min(birthdate || new Date(new Date().getFullYear() - 120, 1, 1), i18n.t("Validations.DateBeforeBirthDate"))
            .minXYearsOld(16, birthdate || new Date(new Date().getFullYear() - 120, 1, 1))
            .presentOrPast()
            .nullable(),
        nationalNumber: yup.string().exactLength(11),
    });
